// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tbl_search th[data-v-6351c6f3] {vertical-align: top;}\n.giftPop > .layer_close[data-v-6351c6f3] {z-index: 10;}\n", ""]);
// Exports
module.exports = exports;
